/*
 * File: PatientCardHeader.js
 * Project: mp-mobile-app
 *
 * Created by Dillon Neukirch on 11/13/2019
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description:
 */
import React from "react";
import { Typography, CardHeader, Avatar } from "@material-ui/core";
import PersonIcon from "@material-ui/icons/Person";
import PatientCardTitle from "./PatientCardTitle";
import PropTypes from "prop-types";
import DateFormatter from "utils/DateFormatter";

const PatientCardHeader = ({ patient }) => {
  return (
    <CardHeader
      avatar={
        <Avatar>
          <PersonIcon />
        </Avatar>
      }
      title={
        <PatientCardTitle
          firstName={patient.firstName}
          lastName={patient.lastName}
          displayId={patient.displayId}
          hasAlerts={patient.hasAlerts}
        />
      }
      subheader={
        <Typography variant="caption">
          {DateFormatter.birthDate(patient.birthdate)}
        </Typography>
      }
    />
  );
};

PatientCardHeader.propTypes = {
  patient: PropTypes.object.isRequired
};

export default PatientCardHeader;
